import React from "react"
import styled from "styled-components"

const StyledTable = styled.div`
  max-width: 100%;
  padding: 1rem 0;
  display: block;
`
export const DetailTable: React.FC = ({ children, ...props }) => {
  return <StyledTable {...props}>{children}</StyledTable>
}
